
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import React from 'react'
import { ClientContext } from '../../../store/context';

function ReservationPaymentMethod() {
    const {paymentMethod,setPaymentMethod} = React.useContext(ClientContext);
    return (
        <FormControl sx={{padding:'10px'}}>
          <FormLabel id="demo-row-radio-buttons-group-label">Payment Method</FormLabel>
          <RadioGroup
            row
            aria-labelledby="dgroup-label"
            name="row-radio-buttons-group"
            value={paymentMethod}
            onClick={event=> setPaymentMethod(event.target.value)}
          >
            <FormControlLabel  value="Cash on Arrival" control={<Radio />} label="Cash on Arrival" />
          </RadioGroup>
        </FormControl>
      );
}

export default ReservationPaymentMethod
